import VueI18n from "vue-i18n";

export default function createLang() {
  return new VueI18n({
    locale: "de",
    messages: {
      en: {
        message: {
          weekdays: [0, 1, 2, 3, 4, 5, 6],
          loading: "Loading…",
          at: "{date} at {time}h",
          larger_map: "Show large map",
          smaller_map: "Close large map",
          to_route: "Route planer",
          location: "Event location",
          description: "Description",
          prices: "Prices",
          event_infos: "Event Information",
          dates: "Dates",
          address_phone: "Phone",
          address_mobile: "Mobile",
          address_email: "E-Mail",
          address_web: "Web",
          arrival_description: "Arrival/accessability",
          price_description: "Additional price information",
          price_from: "Price: from {price}",
          free_access: "Free access",
          advance_booking: "Advance booking possible",
          box_office: "Tickets at box office",
          payments: "Payment methods",
          discount: "Discount Information",
          toTicketing: "Book",
          highlight: "Top-Event",
          operator_address: "Operator Address",
          operator_contact: "Operator Contact Information",
          operator_text: "Operator Information",
          back: "Back",
          more: "More information",
          media: "Media"
        }
      },
      de: {
        message: {
          weekdays: [1, 2, 3, 4, 5, 6, 0],
          loading: "Lade…",
          at: "{date} um {time} Uhr",
          larger_map: "Größere Karte ansehen",
          smaller_map: "Karte verkleinern",
          to_route: "Routenplaner",
          location: "Veranstaltungsort",
          description: "Beschreibung",
          prices: "Preise",
          event_infos: "Merkmale",
          dates: "Weitere Termine",
          address_phone: "Telefon",
          address_mobile: "Mobil",
          address_email: "E-Mail",
          address_web: "Web",
          arrival_description: "Anreise/Erreichbarkeit",
          price_description: "Weiterführende Preisinformationen",
          price_from: "Preis: ab {price}",
          free_access: "Freier Eintritt",
          advance_booking: "Kartenvorverkauf",
          box_office: "Karten an der Abendkasse",
          payments: "Zahlungsmöglichkeiten",
          discount: "Eintrittsinformationen",
          toTicketing: "Buchen",
          highlight: "Top-Veranstaltung",
          operator_address: "Adresse Veranstalter",
          operator_contact: "Kontakt Veranstalter",
          operator_text: "Informationen zum Veranstalter",
          back: "Zurück",
          more: "Weitere Informationen",
          media: "Medien",
          event_news: "Aktuelles",
          shortDescription: "Kurzbeschreibung"
        }
      }
    },
    numberFormats: {
      en: {
        currency: {
          style: "currency",
          currency: "EUR"
        }
      },
      de: {
        currency: {
          style: "currency",
          currency: "EUR"
        }
      }
    }
  });
}
